import {importProvidersFrom, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LayoutModule} from "./layout/portal-layout/layout.module";
import {LayoutBlankModule} from "./layout/blank-layout/layout_blank.module";


import {CoreModule} from "./core/core.module";
import {SharedModule} from "./shared/shared.module";

import {AppService} from "./core/services/base.service";
import {PortalService} from "./core/services/portal.service";
import {LoggingService} from "./core/services/log.service";
import {AuthService} from "./core/services/auth.service";
import {RestfulService} from "./core/services/restful.service";
import {CommonService} from "./shared/services/common.service";
import {UserService} from "../app/core/services/user.service";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {ConfigurationService} from "./core/services/configuration.service";
import {BackupService} from "./core/services/backup.service";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {httpInterceptorProviders} from "./http-interceptors";
import {defineLocale} from "ngx-bootstrap/chronos";
import {itLocale} from "ngx-bootstrap/locale";
import localeIt from '@angular/common/locales/it';
import {registerLocaleData} from "@angular/common";

registerLocaleData(localeIt);

export function createTranslateLoader(http: HttpClient) {
  console.log('translate')
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

defineLocale('it', itLocale);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    LayoutBlankModule,
    BrowserAnimationsModule,
    ToastrModule,
    HttpClientModule,
    BrowserAnimationsModule, // required for ng2-tag-input
    CoreModule,
    LayoutModule,
    LayoutBlankModule,
    SharedModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    TooltipModule.forRoot(),
    ToastrModule.forRoot()

  ],
  providers: [
    UserService,
    AppService,
    PortalService,
    LoggingService,
    AuthService,
    RestfulService,
    CommonService,
    ConfigurationService,
    BackupService,
    { provide: LOCALE_ID, useValue: 'it'},
    importProvidersFrom(HttpClientModule),
    httpInterceptorProviders,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
